/* eslint-disable */
import React, {FC, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Avatar, Button, Col, Divider, Dropdown, Image, Menu, MenuProps, Row, Tooltip } from 'antd';
import {
  AreaChartOutlined,
  BulbOutlined,
  CalendarOutlined,
  CaretDownOutlined,
  CloudDownloadOutlined,
  DashboardOutlined,
  DotChartOutlined,
  FileDoneOutlined,
  FlagOutlined,
  FormOutlined,
  FundOutlined,
  HomeOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MenuOutlined,
  MessageOutlined,
  SettingOutlined,
  UserOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import {
  authState,
  myState,
  profileSwitchState,
  screenSizeState,
  selectedTopNavKeyState,
  siteState
} from 'recoil/atoms';
import { ACLCheck } from 'shared/Helpers';
import {ANONYMOUS_CLIENT_NAME, ANONYMOUS_CLIENT_SHORT_NAME} from 'shared/constants';
import vantageProLogo from 'assets/NPI Vantage Pro Portal logo_w.png';
import vantageBasicLogo from 'assets/NPI Vantage Portal logo_w.png';
import smartBenchLogo from 'assets/SmartBenchLogo.png';
import { MenuInfo } from 'rc-menu/lib/interface';
import './NavBar.scss';
import { SwitchProfileModal } from 'components/molecules/SwitchProfileModal';
import packageInfo from '../../../package.json';
import { SubscriptionLevel } from 'models/User.d';
import currentSubscriptionIcon from 'assets/icon-subscription.svg';
import submitIcon from 'assets/icon-submit.svg';
import blackrockIcon from 'assets/icon-blackrock.svg';
import portfolioIcon from 'assets/icon-portfolio.svg';
// import pinpointIcon from 'assets/icon-pinpoint.svg';
// import supplierdynamicsIcon from 'assets/icon-supplierdynamics.svg';
// import supplierresearchIcon from 'assets/icon-supplierresearch.svg';
import DocumentSearch from 'components/molecules/DocumentSearch';
import { AIMindSparkChatbotModal } from 'components/modals/AIMindSparkChatbotModal';
import AskMindSparkButtonIcon from "assets/AskMindSparkButtonIcon.svg";

export const NavBar: FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  // LOCAL STATE
  const [switchProfileOpen, setSwitchProfileOpen] = useState(false);

  // RECOIL STATE
  const screenSize = useRecoilValue(screenSizeState);
  const { user } = useRecoilValue(authState);
  const [selectedTopNavKey, setSelectedTopNavKey] = useRecoilState(selectedTopNavKeyState);
  const [profileSwitch] = useRecoilState(profileSwitchState);
  const [site, setSite] = useRecoilState(siteState);
  const me = useRecoilValue(myState);
  const [openChatbot, setOpenChatbot] = useState(false);
  // const setPurchaseAnalysisModal = useSetRecoilState(submitPurchaseAnalysisOpenState);

  const isPortfolioView = () => {
    return !!(
      (me?.client.childOrgs && me?.client.childOrgs > 0) ||
      (profileSwitch && profileSwitch.childOrgs > 0 && ACLCheck(['read:portfolio']))
    );
  };

  /**
   * Function to handle logout click event.
   *
   * @async
   * @returns {Promise<void>} - A Promise that resolves to void.
   */
  const logoutClickHandler = async (): Promise<void> => {
    localStorage.removeItem('lastLocation');
    localStorage.removeItem('permissions');
    await logout();
  };

  /**
   * @typedef {Object} ProfileSwitch
   * @property {number} subscription_level_id - The subscription level ID of the profile switch.
   */
  const isGoldProfile: boolean | undefined =
    profileSwitch && profileSwitch.subscription_level_id === SubscriptionLevel.Gold;

  // const showPurchaseAnalysisModal = () => {
  //   setPurchaseAnalysisModal(true);
  // };

  // const supplierInsightsMenuItems: MenuProps['items'] = [
  //   {
  //     key: 'supplierDynamics',
  //     label: (
  //       <Row gutter={4} onClick={() => navigate('/supplier_dynamics')}>
  //         <Col span={19}>
  //           <div className="label">Supplier Dynamics&trade;</div>
  //           <div className="hint">
  //             Determine how negotiable a supplier is based on four key dynamics and in-the-trenches insights from
  //             NPI&apos;s IT procurement analysts.
  //           </div>
  //         </Col>
  //         <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
  //           {/* <AreaChartOutlined style={{ fontSize: 52, color: '#D9D9D9' }} /> */}
  //           <Image src={supplierdynamicsIcon} width={80} preview={false} />
  //         </Col>
  //       </Row>
  //     )
  //   },
  //   ACLCheck(['read:pinpoint']) && ((!profileSwitch && ACLCheck(['read:portofino_full'])) || isGoldProfile)
  //     ? {
  //         key: 'pinPoint',
  //         label: (
  //           <Row gutter={4} onClick={() => navigate('/pinpoint')}>
  //             <Col span={19}>
  //               <div className="label">PinPoint&trade;</div>
  //               <div className="hint">
  //                 Determine how negotiable a supplier is based on four key dynamics and in-the-trenches insights from
  //                 NPI&apos;s IT procurement analysts.
  //               </div>
  //             </Col>
  //             <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
  //               {/* <CompassOutlined style={{ fontSize: 52, color: '#D9D9D9' }} /> */}
  //               <Image src={pinpointIcon} width={80} preview={false} />
  //             </Col>
  //           </Row>
  //         )
  //       }
  //     : null,
  //   (!profileSwitch && ACLCheck(['read:own_inquiry']))
  //     ? {
  //         key: 'research',
  //         label: (
  //           <Row gutter={4} onClick={() => navigate('/research/analyst')}>
  //             <Col span={19}>
  //               <div className="label">Analyst Inquiry</div>
  //               <div className="hint">
  //                 Got a burning question? Get an NPI expert analyst to answer all your queries. Our pool of expert teams
  //                 will surly find the right answers!
  //               </div>
  //             </Col>
  //             <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
  //               {/* <CommentOutlined style={{ fontSize: 52, color: '#D9D9D9' }} /> */}
  //               <Image src={supplierresearchIcon} width={80} preview={false} />
  //             </Col>
  //           </Row>
  //         )
  //       }
  //     : null
  // ];

  // noinspection JSUnusedLocalSymbols,HtmlUnknownAttribute
  const mySubscriptionMenuChildren: MenuProps['items'] = [
    {
      key: 'submitPurchaseAnalysis',
      label: (
        <Row gutter={4} onClick={() => navigate('/submit_purchase')}>
          <Col span={19}>
            <div className="label">Submit A Purchase For Analysis</div>
            <div className="hint">
              Submit another IT purchase to check if you're getting the best deal, spot issues, and get suggestions to
              improve the terms.
            </div>
          </Col>
          <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
            <Image src={submitIcon} width={80} preview={false} />
          </Col>
        </Row>
      )
    },
    {
      key: 'currentSubscription',
      label: (
        <Row gutter={4} onClick={() => navigate('/subscription_purchases')}>
          <Col span={19}>
            <div className="label">View Subscription Data</div>
            <div className="hint">View data for your current and previous subscription periods.</div>
          </Col>
          <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
            <Image src={currentSubscriptionIcon} width={80} preview={false} />
          </Col>
        </Row>
      )
    }
  ];

  const mySmartCalendarMenuChildren: MenuProps['items'] = [
    {
      key: 'ownSmartCalendar',
      label: (
        <Row gutter={4} onClick={() => navigate('/deal_calendar')}>
          <Col span={19}>
            <div className="label">{me ? me.client.name : 'Own'} Smart Calendar&trade;</div>
            <div className="hint">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore.
            </div>
          </Col>
          <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
            <Image src={blackrockIcon} width={80} preview={false} />
          </Col>
        </Row>
      )
    },
    {
      key: 'portfolioSmartCalendar',
      label: (
        <Row gutter={4} onClick={() => navigate('/portfolio_calendar')}>
          <Col span={19}>
            <div className="label">Portfolio Smart Caledar&trade;</div>
            <div className="hint">
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </div>
          </Col>
          <Col span={5} className={'flex flex-col flex-grow text-center place-content-end items-center'}>
            <Image src={portfolioIcon} width={80} preview={false} />
          </Col>
        </Row>
      )
    }
  ];

  /**
   * Represents the menu items for the smartBenchMenu.
   *
   * @type {MenuProps['items']}
   */
  const smartBenchMenuItems: MenuProps['items'] = [
    {
      key: 'divider',
      disabled: true,
      label: <Divider style={{ borderLeft: site === 'vantage' ? '1px solid rgba(255, 255, 255, 0.65)' : '1px solid rgba(0, 0, 0, 0.65)', height: '2em' }} type="vertical" />
    },
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to={'/sb'}>Home</Link>
    },
    {
      key: 'contracts',
      label: <Link to={'/sb/contracts'}>Contracts</Link>,
      icon: <FormOutlined />
    },
    {
      key: 'reports',
      label: <Link to={'/sb/reports'}>Reports</Link>,
      icon: <FileDoneOutlined />
    },
    {
      key: 'priceBenchmark',
      label: <Link to={'/sb/benchmarks/product'}>Benchmarks</Link>,
      icon: <DotChartOutlined />
    },
    {
      key: 'askMindSparkAI',
      label: <span onClick={() => setOpenChatbot(true)}>FMV Miner&trade;</span>,
      icon: <img src={AskMindSparkButtonIcon} alt="Icon"/>
    }
  ];

  const vangardMenuItems: MenuProps['items'] = [
    {
      key: 'divider',
      disabled: true,
      label:
        screenSize > 4 ? (
          <Divider style={{ borderLeft: '1px solid rgba(255, 255, 255, 0.65)', height: '2em' }} type="vertical" />
        ) : undefined
    },
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to={'/'}>Home</Link>
    },
    isPortfolioView()
      ? {
          key: 'dealCalendarEquityFirm',
          popupClassName: 'nav-submenu',
          icon: <CalendarOutlined />,
          label: (
            <>
              Smart Calendar <CaretDownOutlined />
            </>
          ),
          children: mySmartCalendarMenuChildren
        }
      : (!profileSwitch && ACLCheck(['read:portofino_full'])) || isGoldProfile
      ? {
          key: 'dealCalendar',
          popupClassName: 'nav-submenu',
          icon: <CalendarOutlined />,
          label: <Link to={'/deal_calendar'}>Smart Calendar&trade;</Link>
        }
      : null,

    // ((!profileSwitch && ACLCheck(['read:portofino_full'])) || isGoldProfile)
    //   ? {
    //       key: 'supplierInsights',
    //       icon: <CaretDownOutlined />,
    //       popupClassName: 'nav-submenu',
    //       label: 'Supplier Insights',
    //       children: supplierInsightsMenuItems
    //     }
    //   : null,
    (!profileSwitch && ACLCheck(['read:supplier_dynamics'])) || isGoldProfile
      ? {
          key: 'supplierDynamics',
          icon: <AreaChartOutlined />,
          popupClassName: 'nav-submenu',
          label: <Link to={'/supplier_dynamics'}>Supplier Dynamics&trade;</Link>
        }
      : null,
    // (!profileSwitch && !ACLCheck(['read:portofino_full']) && !isGoldProfile) || (profileSwitch && !isGoldProfile)
    //   ? {
    //       key: 'supplierDynamics',
    //       icon: <AreaChartOutlined />,
    //       popupClassName: 'nav-submenu',
    //       label: <Link to={'/supplier_dynamics'}>Supplier Dynamics&trade;</Link>
    //     }
    //   : null,
    {
      key: 'mySubscription',
      icon: <CaretDownOutlined />,
      popupClassName: 'nav-submenu',
      label: 'NPI Account',
      children: mySubscriptionMenuChildren
    },
    {
      key: 'npiResearch',
      icon: <BulbOutlined />,
      label: <Link to={'/resources'}>Resources</Link>
    },
    {
      key: 'blog',
      icon: <MessageOutlined />,
      label: (
        <Link to={'https://npifinancial.com/blog'} target="_blank">
          Blog
        </Link>
      )
    },
    screenSize >= 6
      ? {
          key: 'docSearch',
          label: <DocumentSearch />
        }
      : null
  ];

  /**
   * Represents the admin menu children.
   *
   * @type {MenuProps['items']}
   */
  const adminMenuChildren: MenuProps['items'] = [
    ACLCheck(['update:site_wide_admin', 'update:all_companies'])
      ? {
          key: 'accountAdmin',
          label: <Link to={'/account_admin'}>Account Administration</Link>,
          icon: <UserOutlined />
        }
      : null,
    ACLCheck(['update:site_wide_admin', 'update:banner_ad'])
      ? {
          key: 'bannerAdmin',
          label: <Link to={'/site_administration'}>Site Administration</Link>,
          icon: <FlagOutlined />
        }
      : null
  ];

  /**
   * Represents the items in the User menu. Each item in the menu has a specific key,
   * an optional icon, and a label. The label can be a string, JSX element,
   * or a React component.
   */
  const items: MenuProps['items'] = [
    {
      key: 'username',
      label: (
        <Row style={{ width: 240 }}>
          <Col span={4}>
            {(profileSwitch && (
              <Avatar size={32} style={{ backgroundColor: 'red', cursor: 'pointer' }}>
                {profileSwitch?.anonymous ? ANONYMOUS_CLIENT_SHORT_NAME : profileSwitch.name.charAt(0)}
              </Avatar>
            )) || (
              <Avatar size={32} style={{ backgroundColor: '#666666', cursor: 'pointer' }}>
                {user ? user.given_name?.charAt(0) : ''}
              </Avatar>
            )}
          </Col>
          <Col span={20}>
            {profileSwitch ? (
              <strong>{profileSwitch?.anonymous ? ANONYMOUS_CLIENT_NAME : profileSwitch.name}</strong>
            ) : (
              <>
                <strong>
                  {user.given_name} {user.family_name}
                </strong>
                <div>{user.email}</div>
              </>
            )}
          </Col>
        </Row>
      )
    },
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: <Link to={'/user_admin'}>Your Profile</Link>
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: <div onClick={logoutClickHandler}>Logout</div>
    },
    {
      key: 'version',
      label: <div>{`Version: ${packageInfo.version}`}</div>,
      icon: <CloudDownloadOutlined />
    }
  ];

  /**
   * Handles the change of the top navigation menu key.
   *
   * @param {MenuInfo} item - The selected menu item.
   * @returns {void}
   */
  const handleTopNavMenuKeyChange = (item: MenuInfo): void => {
    setSelectedTopNavKey(item.key);
  };

  /**
   * Handles toggling between 'smartbench' and 'vantage' sites.
   *
   * @function handleSiteToggle
   * @returns {void}
   */
  const handleSiteToggle = (): void => {
    setSite(site === 'smartbench' ? 'vantage' : 'smartbench');
    navigate(site === 'smartbench' && ACLCheck(['read:smartbench_access']) ? '/' : '/sb');
  };

  /**
   * Function to handle click on the home button.
   *
   * @returns {void}
   */
  const handleHomeClick = (): void => {
    navigate(site === 'smartbench' && ACLCheck(['read:smartbench_access']) ? '/sb' : '/');
  };

  const rightMenu: MenuProps['items'] = [
    ACLCheck(['read:smartbench_access']) && ACLCheck(['read:switch_user_profile'])
      ? {
          key: 'profileSwitch',
          label: (
            <Button size="large" type="link" onClick={() => setSwitchProfileOpen(true)} icon={<UserSwitchOutlined />} />
          )
        }
      : null,
    ACLCheck(['read:smartbench_access']) && site === 'smartbench'
      ? {
          key: 'switchToVantage',
          label: (
            <Tooltip placement='bottom' title={'Switch to Vantage'}>
              <Button onClick={handleSiteToggle} size="large" type="link" icon={<DashboardOutlined />} />
            </Tooltip>
          )
        }
      : null,
    ACLCheck(['read:smartbench_access']) && site === 'vantage'
      ? {
          key: 'switchToVantage',
          label: (
            <Tooltip placement='bottom'  title={'Switch to SmartBench'}>
              <Button onClick={handleSiteToggle} size="large" type="link" icon={<FundOutlined />} />
            </Tooltip>
          )
        }
      : null,
    ACLCheck(['update:site_wide_admin', 'update:banner_ad', 'update:all_companies'])
      ? {
          key: 'adminMenu',
          label: (
            <Dropdown menu={{ items: adminMenuChildren }} trigger={['hover']} className="left-padded">
              <Button size="large" type="link" icon={<SettingOutlined />} />
            </Dropdown>
          )
        }
      : null,
    !user
      ? {
          key: 'loading',
          label: (
            <Avatar size={26} className="bg-[#666] cursor-pointer">
              <LoadingOutlined />
            </Avatar>
          )
        }
      : null,
    user?.given_name && user?.family_name
      ? {
          key: 'userMenu',
          label: (
            <Dropdown menu={{ items }}>
              {(profileSwitch && (
                <Avatar size={26} className="bg-[red] cursor-pointer">
                  {profileSwitch?.anonymous ? ANONYMOUS_CLIENT_SHORT_NAME : profileSwitch.name.charAt(0)}
                </Avatar>
              )) || (
                <Avatar size={26} className="bg-[#666] cursor-pointer">
                  {user.given_name.charAt(0) + user.family_name.charAt(0)}
                </Avatar>
              )}
            </Dropdown>
          )
        }
      : null,
    !user?.given_name && !user?.family_name
      ? {
          key: 'unknownUser',
          label: (
            <Dropdown menu={{ items }} trigger={['click']} className="left-padded">
              <Avatar size={26} className="bg-[#666] cursor-pointer">
                ?
              </Avatar>
            </Dropdown>
          )
        }
      : null
  ];

  return (
    <div id="navigationBarId">
      <Row className={`${site === 'vantage' ? 'nav-bar-vantage navigation-bar-vantage' : 'nav-bar-smartbench navigation-bar-smartbench'}`} wrap={false}>
        {screenSize > 3 && (
          <Col flex={site === 'vantage' ? '180px' : '300px'}>
            {site === 'vantage' && (
              <Button type="link" className="p-0" onClick={handleHomeClick}>
                {(((isGoldProfile && ACLCheck(['read:portofino_full'])) ||
                  (!profileSwitch && ACLCheck(['read:portofino_full']))) && (
                  <img style={{height: 40}} src={vantageProLogo} alt="NPI Vantage&trade; Pro"/>
                )) || <img style={{height: 40}} src={vantageBasicLogo} alt="NPI SmartSpend&trade;"/>}
              </Button>
            )}
            {site === 'smartbench' && (
              <Button type="link" className="p-0" onClick={handleHomeClick}>
                <img style={{height: 40}} src={smartBenchLogo} alt="NPI SmartBench&trade;"/>
              </Button>
            )}
          </Col>
        )}
        <Col flex="auto">
          {ACLCheck(['read:deal_calendar_all', 'read:deal_calendar_company', 'read:portofino']) && (
            <Menu
              onClick={handleTopNavMenuKeyChange}
              style={{ fontSize: screenSize > 4 ? 16 : 14 }}
              key={'subscriptionMenu'}
              triggerSubMenuAction="click"
              overflowedIndicator={<MenuOutlined />}
              mode="horizontal"
              selectedKeys={selectedTopNavKey ? [selectedTopNavKey] : []}
              items={
                ACLCheck(['read:smartbench_access']) && site === 'smartbench' ? smartBenchMenuItems : vangardMenuItems
              }
            />
          )}
        </Col>
        <Col style={{ textAlign: 'right' }} flex="170px" className={'nav-right-menu'}>
          <div style={{ textAlign: 'right' }}>
            <Menu
              style={{ fontSize: screenSize > 4 ? 16 : 14 }}
              key={'rightMenu'}
              triggerSubMenuAction="click"
              overflowedIndicator={<MenuOutlined />}
              mode="horizontal"
              selectedKeys={[]}
              items={rightMenu}
            />
          </div>
        </Col>
      </Row>
      {ACLCheck(['read:smartbench_access']) && ACLCheck(['read:switch_user_profile']) && (
        <SwitchProfileModal
          open={switchProfileOpen}
          onCancel={() => setSwitchProfileOpen(false)}
          onSwitchProfile={() => setSwitchProfileOpen(false)}
        />
      )}
      <AIMindSparkChatbotModal
        maskClosable={false}
        open={openChatbot}
        closeModal={() => setOpenChatbot(false)}
      />
    </div>
  );
};
